import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";

// A live countdown, not a one-off warning — sits at the top and starts blinking once the
// trial has 2 days or fewer left, so it's impossible to miss right before a trial-created
// campaign locks.
export function TrialCountdownBanner({ billing, className = "", variant = "strip" }) {
  const navigate = useNavigate();
  if (!billing || billing.subscription_status !== "trialing" || !billing.trial_ends_at) return null;

  const msLeft = new Date(billing.trial_ends_at).getTime() - Date.now();
  const daysLeft = Math.max(0, Math.ceil(msLeft / (1000 * 60 * 60 * 24)));
  const blinking = daysLeft <= 2;
  const colorClasses = blinking ? "bg-[#D90429]/25 text-[#ff6b81] animate-pulse" : "bg-[#D4AF37]/10 text-[#D4AF37] hover:bg-[#D4AF37]/20";
  const layoutClasses = variant === "pill"
    ? "absolute top-16 left-1/2 -translate-x-1/2 z-30 rounded-full px-5 py-2.5 backdrop-blur-2xl border border-current/30"
    : "py-2";

  return (
    <div
      data-testid="trial-countdown-banner"
      onClick={() => navigate("/billing")}
      className={`flex items-center justify-center gap-2 text-xs uppercase tracking-widest cursor-pointer transition-colors duration-200 ${colorClasses} ${layoutClasses} ${className}`}
    >
      <Clock className="w-3.5 h-3.5" />
      {daysLeft <= 0
        ? "Your free trial ends today — subscribe to keep your campaigns"
        : `Free trial ends in ${daysLeft} day${daysLeft === 1 ? "" : "s"} — subscribe to keep your campaigns`}
    </div>
  );
}
